import { PreferenceOption } from './preference-option.model';
import { useDefault } from '../../../../common';

export class Preference {
  id: string;
  type: string;
  name: string;
  userPrefSelected: boolean;
  preferenceValue: string;
  notes: string;
  options: PreferenceOption[] = [];

  constructor(preferenceData: any) {
    this.id = useDefault(preferenceData.name, null);
    this.type = useDefault(preferenceData.type, '');
    this.name = useDefault(preferenceData.description, '');
    this.userPrefSelected = useDefault(preferenceData.userPrefSelected, false);
    this.preferenceValue = useDefault(preferenceData.preferenceValue, '');
    this.notes = useDefault(preferenceData.notes, null);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/stay-preferences/preference.model.ts